<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="snRule"
          @delete="deleteHandle"
          @addOrEdit="addEditHandle"
          @select="selectHandle"
          @reset="resetHandle">
        <template slot="otherBtn">
          <el-button v-if="(selection.length > 0 && limits.delAuth)" type="danger" @click="deleteBatch">批量删除</el-button>
        </template>
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
            <el-form-item label="规则编号">
              <el-input v-model.trim="filter.snRuleNo" placeholder="请输入规则编号"/>
            </el-form-item>
            <el-form-item label="规则样式">
              <el-input v-model.trim="filter.snRuleExpression" placeholder="请输入规则样式"/>
            </el-form-item>
            <el-form-item label="规则类型">
              <el-select v-model="filter.snType" placeholder="请选择规则类型">
                <el-option v-for="item in snTypes" :key="item.code" :label="item.name" :value="item.code"/>
              </el-select>
            </el-form-item>
            <el-form-item label="规则状态">
              <el-select v-model="filter.status" placeholder="请选择规则状态">
                <el-option v-for="item in snStatus" :key="item.code" :label="item.name" :value="item.code"/>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
        <el-table-column type="selection" align="center" width="55" prop="selection"/>
        <el-table-column prop="snRuleNo" align="center" label="规则编号" width="120"/>
        <el-table-column prop="snTypeName" align="center" label="规则类型" width="120"/>
        <el-table-column prop="snRuleExpression" width="240" align="left" label="规则样式"/>
        <el-table-column prop="snRuleExpressionDesc" align="left" label="规则描述"/>
        <el-table-column prop="snLength" align="center" label="字符总数" width="80"/>
        <el-table-column
            prop="snRuleDesc"
            align="left"
            width="180"
            show-overflow-tooltip
            label="备注"/>
        <el-table-column prop="statusName" align="center" label="状态" width="80"/>
        <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="120px"
            prop="action">
          <template slot-scope="scope">
            <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>
            <el-button v-if="delAuth" type="danger" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </view-table>
      <bar-code-rules-edit ref="editPage" :sn-status="snStatus" :sn-types="snTypes" @save-success="loadData(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import BarCodeRulesEdit from "@/views/information/BarCodeRules/BarCodeRulesEdit";

  export default {
    name: "BarCodeRulesList",
    components: { BarCodeRulesEdit, ViewTable },
    data() {
      return {
        limits:{
          addAuth: this.$auth(148),
          editAuth: this.$auth(149),
          delAuth: this.$auth(150),
        },
        columnsProperty:[
          {
            key:"snRuleNo",
            align:"center",
            width:100,
          },
          {
            key:"snTypeName",
            align:"center",
            width:120,
          },
          {
            key:"snRuleExpression",
            align:"left",
            minWidth:160,
            tooltip:true,
          },
          {
            key:"snRuleExpressionDesc",
            align:"left",
            minWidth:240,
            tooltip:true,
          },
          {
            key:"snLength",
            align:"center",
            width:90,
          },
          {
            key:"snRuleDesc",
            align:"left",
            minWidth:240,
            tooltip:true,
          },
          {
            key:"statusName",
            align:"center",
            width:90,
          },
          {
            key:"creatorName",
            align:"center",
            width:90,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
        snTypes: [],
        snStatus: [],
        searchShow: false,
        filter: {
          snRuleNo: "",
          snRuleExpression: "",
          snType: "",
          status: "",
        },
      };
    },
    mounted() {
      this.getRuleType();
    },
    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
      },

      // 获取规则类型
      getRuleType() {
        this.$http.get("basic", "dictionaries/dictEnum/SnType").then((resp) => {
          if (resp.success) {
            this.snTypes = resp.data;
            this.getRuleStatus();
          }
        });
      },

      // 获取状态
      getRuleStatus() {
        this.$http.get("basic", "dictionaries/dictEnum/CommonStatus").then((resp) => {
          if (resp.success) {
            this.snStatus = resp.data;
          }
        });
      },

      // 单个删除
      deleteHandle(row) {
        this.$http.delete("basic", "snRule", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
          }
        });
      },

      // 批量删除
      deleteBatch() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "snRule/batchDelete", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
